import { apiSlice } from './api/apiSlice';

export const raceReportSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get hourly race scores for all employees
    getHourlyRaceScores: builder.query({
      query: (date) => ({
        url: `/race-report/hourly-scores${date ? `?date=${date}` : ''}`,
        method: 'GET',
      }),
      transformResponse: (response) => {
        // Backend returns: { success: true, message: "...", data: { employees: [...], timestamp: ... } }
        if (response?.success && response?.data) {
          return response.data;
        }
        // Fallback for direct data
        return response?.data || response || { employees: [], timestamp: new Date() };
      },
      providesTags: ['RaceReport'],
    }),

    // Get employee's daily race report
    getEmployeeDailyReport: builder.query({
      query: ({ employeeId, date }) => ({
        url: `/race-report/employee/${employeeId}/daily${date ? `?date=${date}` : ''}`,
        method: 'GET',
      }),
      transformResponse: (response) => {
        return response?.data || response || null;
      },
      providesTags: ['RaceReport'],
    }),

    // Submit daily race report
    submitDailyReport: builder.mutation({
      query: (data) => ({
        url: '/race-report/submit-daily',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['RaceReport'],
    }),
  }),
});

export const {
  useGetHourlyRaceScoresQuery,
  useGetEmployeeDailyReportQuery,
  useSubmitDailyReportMutation,
  useLazyGetHourlyRaceScoresQuery,
  useLazyGetEmployeeDailyReportQuery,
} = raceReportSlice;
